import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './landingPage/Header';
import Footer from './landingPage/Footer';

const MainLayout = () => {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
